import { COLORS } from '../../../constants';

const styles = {
  root: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  checkboxRoot: {
    marginRight: 5,
    padding: 0,
    '& svg': {
      color: COLORS.GREY,
    },
  },
  checkboxChecked: {
    '& svg': {
      color: COLORS.GREEN,
    },
  },
  label: {
    flexGrow: 1,
    marginTop: 4,
    fontSize: '0.875rem',
  },
  disabled: {
    // we need to make the colour to be the same as the checkbox in disabled mode
    color: 'rgba(0, 0, 0, 0.26)',
  },
  errorText: {
    color: COLORS.RED,
    lineHeight: 1.2,
  },
};

export default styles;
